// Calls to admin_backend /admin/zoho-billing/*. Every response is
// { status, msg, data }; anything but status 200 is thrown as an Error(msg).
const BASE = `${process.env.REACT_APP_SERVER_URL}/admin/zoho-billing`;

export async function zb(path, { method = "GET", body, form } = {}) {
  const opts = { method, credentials: "include" };
  if (form) opts.body = form;
  else if (body !== undefined) {
    opts.headers = { "Content-Type": "application/json" };
    opts.body = JSON.stringify(body);
  }
  const res = await fetch(`${BASE}${path}`, opts);
  const json = await res.json().catch(() => ({}));
  if (!res.ok || json.status !== 200) {
    throw new Error(json.msg || `Request failed (${res.status})`);
  }
  return json.data;
}

export const fileUrl = (runId, name) =>
  `${BASE}/runs/${runId}/files/${encodeURIComponent(name)}`;

export const BUSY = ["previewing", "posting", "running"];

export const STATUS_LABELS = {
  uploaded: "Uploaded",
  previewing: "Previewing…",
  needs_mapping: "Needs SKU mapping",
  previewed: "Preview ready",
  no_changes: "Nothing to apply",
  posting: "Posting…",
  posted: "Posted",
  posted_with_warnings: "Posted with warnings",
  plan_changed: "Plan changed",
  failed: "Failed",
  cancelled: "Cancelled",
  interrupted: "Interrupted",
  running: "Running…",
  done: "Done",
};

export const KIND_LABELS = {
  ingram: "Ingram statement",
  google: "Google bills",
  credits: "Vendor credits",
  payments: "Advance payments",
  recon: "Reconciliation",
};

export function inr(n) {
  if (n == null || n === "") return "—";
  const v = Number(n);
  const abs = Math.abs(v).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${v < 0 ? "−" : ""}₹${abs}`;
}

export function when(d) {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return String(d);
  }
}
